import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/products";

// Token is sent (when logged in) so staff can use { all: 1 } / see hidden products.
const getAll = (params = {}) => axios.get(API_URL, { params, headers: authHeader() });

const get = (id) => axios.get(`${API_URL}/${id}`, { headers: authHeader() });

// Build multipart FormData from a product payload.
//   fields: product columns (name, price, description, image_url = cover, catalog_id,
//           sub_catalog_id) + extra-image meta (removeImageIds, order, captions, newCaptions)
//   files:  array<File> — extra images, uploaded under field "images"
const JSON_FIELDS = ["removeImageIds", "order", "captions", "newCaptions"];
const buildForm = (fields = {}, files = []) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v === undefined) return;
    if (JSON_FIELDS.includes(k)) fd.append(k, JSON.stringify(v));
    else fd.append(k, v === null ? "" : v);
  });
  (files || []).forEach((f) => fd.append("images", f));
  return fd;
};

const multipartOpts = (onProgress) => ({
  headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  onUploadProgress: (e) => {
    if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
  },
});

const create = (fields, files = [], onProgress) =>
  axios.post(API_URL, buildForm(fields, files), multipartOpts(onProgress));

const update = (id, fields, files = [], onProgress) =>
  axios.put(`${API_URL}/${id}`, buildForm(fields, files), multipartOpts(onProgress));

const remove = (id) =>
  axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

const ProductService = { getAll, get, create, update, remove };

export default ProductService;
